document.addEventListener('DOMContentLoaded', function () {
  const menuButton = document.querySelector('[data-menu-toggle]');
  const menu = document.querySelector('[data-menu]');
  if (menuButton && menu) {
    menuButton.addEventListener('click', function () {
      const open = menu.classList.toggle('open');
      menuButton.setAttribute('aria-expanded', String(open));
    });
    document.querySelectorAll('[data-menu] a').forEach(function (link) {
      link.addEventListener('click', function () {
        menu.classList.remove('open');
        menuButton.setAttribute('aria-expanded', 'false');
      });
    });
  }

  function setActiveThumbnailById(imageId) {
    const thumbs = document.querySelectorAll('.thumb[data-img]');
    thumbs.forEach(function (thumb) {
      const isActive = imageId && String(thumb.dataset.imageId || '') === String(imageId);
      thumb.classList.toggle('is-active', isActive);
      thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
    });
  }

  function setMainProductImage(src, altText, imageId) {
    const image = document.querySelector('#main-product-image');
    if (!image || !src) return;
    image.src = src;
    if (altText) image.alt = altText;
    if (imageId) image.dataset.currentImageId = String(imageId);
    setActiveThumbnailById(imageId);
  }

  document.querySelectorAll('.thumb[data-img]').forEach(function (button) {
    button.addEventListener('click', function () {
      setMainProductImage(button.dataset.img, button.dataset.imgAlt, button.dataset.imageId);
    });
  });

  const productJsonNode = document.getElementById('product-json');
  const moneyNode = document.getElementById('product-money-config');
  const productForm = document.getElementById('product-form');

  if (productJsonNode && productForm) {
    const productData = JSON.parse(productJsonNode.textContent);
    const moneyConfig = moneyNode ? JSON.parse(moneyNode.textContent) : { currency: 'EUR' };
    const variantSelect = productForm.querySelector('[data-variant-select]');
    const quantityInput = productForm.querySelector('.qty-input');
    const priceEl = document.querySelector('[data-product-price]');
    const compareWrap = document.querySelector('[data-compare-price]');
    const compareValue = compareWrap ? compareWrap.querySelector('s') : null;
    const statusEl = document.querySelector('[data-variant-status]');
    const stickyBar = document.querySelector('[data-sticky-atc]');
    const stickyPrice = document.querySelector('[data-sticky-price]');
    const stickyVariant = document.querySelector('[data-sticky-variant]');
    const mainAtc = productForm.querySelector('[data-main-atc]');
    const mainBuyNow = productForm.querySelector('[data-main-buy-now]');
    const stickyBuy = document.querySelector('[data-sticky-buy]');
    const optionCurrentNodes = document.querySelectorAll('[data-option-current]');
    const optionButtons = productForm.querySelectorAll('[data-option-value]');
    const mainImage = document.getElementById('main-product-image');

    function getVariantImageData(variant) {
      if (!variant) return null;
      if (variant.featured_image && variant.featured_image.src) {
        return {
          src: variant.featured_image.src,
          alt: variant.featured_image.alt || (mainImage ? mainImage.alt : ''),
          id: variant.featured_image.id || variant.image_id || ''
        };
      }
      if (variant.featured_media && variant.featured_media.preview_image && variant.featured_media.preview_image.src) {
        return {
          src: variant.featured_media.preview_image.src,
          alt: variant.featured_media.preview_image.alt || (mainImage ? mainImage.alt : ''),
          id: variant.featured_media.preview_image.id || variant.featured_media.id || ''
        };
      }
      return null;
    }

    const formatter = new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {
      style: 'currency',
      currency: moneyConfig.currency || 'EUR'
    });

    // Respect Shopify's server-selected SKU, including ?variant= links.
    const initialVariant = productData.variants.find(function (variant) {
      return variantSelect && String(variant.id) === String(variantSelect.value);
    }) || productData.variants.find(function (variant) { return variant.available; }) || productData.variants[0];
    let selectedOptions = initialVariant ? initialVariant.options.slice() : [];

    function formatMoney(cents) {
      return formatter.format((cents || 0) / 100);
    }

    function findVariant(options) {
      return productData.variants.find(function (variant) {
        return variant.options.every(function (value, index) {
          return value === options[index];
        });
      });
    }

    function getMatchesForOption(optionIndex, value) {
      return productData.variants.filter(function (variant) {
        return variant.options.every(function (variantValue, index) {
          if (index === optionIndex) return variantValue === value;
          return !selectedOptions[index] || variantValue === selectedOptions[index];
        });
      });
    }

    function syncAvailabilityUI() {
      optionButtons.forEach(function (button) {
        const optionIndex = Number(button.dataset.optionIndex);
        const optionValue = button.dataset.optionValueText;
        const matches = getMatchesForOption(optionIndex, optionValue);
        const hasMatch = matches.length > 0;
        const hasAvailable = matches.some(function (variant) { return variant.available; });

        button.disabled = !hasMatch;
        button.classList.toggle('is-unavailable', !hasMatch);
        button.classList.toggle('is-soldout', hasMatch && !hasAvailable);

        if (button.classList.contains('variant-chip')) {
          const sub = button.querySelector('.variant-chip-sub');
          if (sub) {
            sub.textContent = !hasMatch ? 'Nicht verfügbar' : (hasAvailable ? '' : 'Nicht auf Lager');
          }
        }
      });
    }

    function updateActiveButtons() {
      optionButtons.forEach(function (button) {
        const optionIndex = Number(button.dataset.optionIndex);
        const isActive = selectedOptions[optionIndex] === button.dataset.optionValueText;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      optionCurrentNodes.forEach(function (node) {
        const index = Number(node.dataset.optionCurrent);
        node.textContent = selectedOptions[index] || '';
      });
    }

    function updateVariantDisplay() {
      const variant = findVariant(selectedOptions);
      const inStock = !!(variant && variant.available);

      if (variantSelect && variant) variantSelect.value = String(variant.id);

      if (priceEl) priceEl.textContent = formatMoney(variant ? variant.price : 0);
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant ? variant.price : 0);

      if (compareWrap && compareValue) {
        if (variant && variant.compare_at_price && variant.compare_at_price > variant.price) {
          compareWrap.hidden = false;
          compareValue.textContent = formatMoney(variant.compare_at_price);
        } else {
          compareWrap.hidden = true;
          compareValue.textContent = '';
        }
      }

      if (statusEl) {
        statusEl.textContent = variant ? (inStock ? 'Verfügbar' : 'Ausverkauft') : 'Variante nicht verfügbar';
        statusEl.classList.toggle('is-soldout', !!variant && !inStock);
      }

      const summary = selectedOptions.filter(Boolean).join(' / ');
      if (stickyVariant) stickyVariant.textContent = summary;

      const variantImage = getVariantImageData(variant);
      if (variantImage && variantImage.src) {
        const normalizedSrc = variantImage.src.replace(/^\/\//, 'https://');
        setMainProductImage(normalizedSrc, variantImage.alt, variantImage.id);
      }

      [mainAtc, mainBuyNow, stickyBuy].forEach(function (button) {
        if (!button) return;
        button.disabled = !variant || !inStock;
      });

      if (mainAtc) mainAtc.textContent = inStock ? 'IN DEN WARENKORB ↗' : 'AUSVERKAUFT';
      if (mainBuyNow) mainBuyNow.textContent = inStock ? 'JETZT KAUFEN' : 'NICHT VERFÜGBAR';
      if (stickyBuy) stickyBuy.textContent = inStock ? 'JETZT KAUFEN' : 'AUSVERKAUFT';
    }

    function refreshVariantUI() {
      updateActiveButtons();
      syncAvailabilityUI();
      updateVariantDisplay();
    }

    optionButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.disabled) return;
        const optionIndex = Number(button.dataset.optionIndex);
        selectedOptions[optionIndex] = button.dataset.optionValueText;
        if (!findVariant(selectedOptions)) {
          const candidates = productData.variants.filter(function (variant) { return variant.options[optionIndex] === selectedOptions[optionIndex]; });
          const alternative = candidates.find(function (variant) { return variant.available; }) || candidates[0];
          if (alternative) selectedOptions = alternative.options.slice();
        }
        refreshVariantUI();
      });
    });

    productForm.querySelectorAll('[data-qty-adjust]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (!quantityInput) return;
        const current = Math.max(1, parseInt(quantityInput.value || '1', 10));
        quantityInput.value = button.dataset.qtyAdjust === 'plus' ? current + 1 : Math.max(1, current - 1);
      });
    });

    function toggleStickyBar() {
      if (!stickyBar || !mainAtc) return;
      const rect = mainAtc.getBoundingClientRect();
      const shouldShow = rect.bottom < 0 || rect.top > window.innerHeight;
      stickyBar.classList.toggle('is-visible', shouldShow);
    }

    function buyNow() {
      const variant = findVariant(selectedOptions);
      if (!variant || !variant.available) return;
      const qty = Math.max(1, parseInt(quantityInput ? quantityInput.value : '1', 10) || 1);
      [mainBuyNow, stickyBuy].forEach(function (button) { if (button) button.disabled = true; });
      fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: variant.id, quantity: qty }] })
      }).then(function (response) {
        if (!response.ok) throw new Error('Warenkorb konnte nicht aktualisiert werden');
        window.location.href = '/checkout';
      }).catch(function () {
        [mainBuyNow, stickyBuy].forEach(function (button) { if (button) button.disabled = false; });
        if (statusEl) statusEl.textContent = 'Bitte erneut versuchen oder den Warenkorb verwenden.';
      });
    }
    [mainBuyNow, stickyBuy].forEach(function (button) {
      if (button) button.addEventListener('click', buyNow);
    });

    refreshVariantUI();
    if (mainImage && mainImage.dataset.currentImageId) {
      setActiveThumbnailById(mainImage.dataset.currentImageId);
    }
    toggleStickyBar();
    window.addEventListener('scroll', toggleStickyBar, { passive: true });
    window.addEventListener('resize', toggleStickyBar);
  }
});

/* Native Shopify country localization: submit form to update market and currency. */
document.addEventListener('change',function(event){
  const select=event.target.closest('[data-country-selector]');
  if(!select)return;
  const form=select.form;
  if(form)form.submit();
});
